import * as yup from 'yup';

const phoneRegExp = /^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/;

export const getUpdateCommercialSchema = yup.object().shape({
  firstName: yup.string().required('Le prénom est requis'),
  lastName: yup.string().required('Le nom est requis'),
  type: yup.string().required('Ce champs est requis'),
  email: yup
    .string()
    .email("Le format de l'adresse email est invalide")
    .required('Une adresse email est requise'),
  phone: yup
    .string()
    .matches(phoneRegExp, 'Numéro de téléphone invalide')
    .required('Un numéro de téléphone est requis.'),
  siret: yup.string().required('Ce champs est requis'),
  tva: yup.string(),
  city: yup.string().required('Ce champs est requis'),
  department: yup.string().required('Ce champs est requis'),
  region: yup.string().required('Ce champs est requis'),
});
